import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

class EmoticonOnComment extends Component {
    @autobind
    handleChange(value, property) {
        const { onChange } = this.props
        let newObject = {};
        newObject[property] = value;
        onChange(
            Object.assign({},  this.props.data, {
                setting: Object.assign({},  this.props.data.setting, newObject),
                validated: true
            })
        )
    }

    render() {
        const { plugin, data } = this.props;
        return (
            <div className="desc_plugin21">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                {this.props.saveButton()}
            </div>
        )
    }
}

EmoticonOnComment.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default EmoticonOnComment
